import { useLocation, useNavigate } from "react-router-dom";
import notificationIcon from "../../../assets/dental-inden/icons/notificationIcon.svg";
import "./style.css";
import { useDispatch } from "react-redux";

import { _onClearDentalRecordData } from "../../../redux/actions/dentalRecordAction";
import Breadcrumb from "../breadcrumb/Breadcrumb";

const AppHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  // Remove trailing slashes for accurate comparison
  const currentPath = location.pathname.replace(/\/$/, "");

  // Map of URL paths to page titles
  const pageTitleMap = {
    "/dental-identification/dashboard": "Dashboard",
    "/dental-identification/projects":
      "Dashboard - Project Management For Dental Identification",
    "/dental-identification/new-project": "Create New Project",
    "/profile": "Profile", // Add other pages as needed
    "/dental-identification/case-registration/am": "AM Registration", // Add other pages as needed
    "/dental-identification/case-registration/pm": "PM Registration", // Add other pages as needed
    "/dental-identification/case/add-dental-record": "Dental Record", // Add other pages as needed
    "/dental-identification/profile": "My Profile", // Add other pages as needed
    "/dental-identification/about-us": "About Us", // Add other pages as needed
    "/dental-identification/settings": "Settings", // Add other pages as needed
    "/dental-identification/support": "Support", // Add other pages as needed
  };

  // Default title from the map
  let title = pageTitleMap[currentPath];

  // If the path is /projects/details/:id, set the title to "Project Details"
  if (currentPath.startsWith("/dental-identification/projects/details")) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (pathParts.length === 5 && pathParts[4]) {
      title = "Project Details";
    }
  }
  // If the path is /dental-identification/projects/case/results/i:d, set the title to "Project Details"
  if (currentPath.startsWith("/dental-identification/projects/case/results")) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (pathParts.length === 6 && pathParts[4] === "results" && pathParts[5]) {
      title = "Results";
    }
  }
  // If the path is /dental-identification/projects/case/results/i:d, set the title to "Project Details"
  if (
    currentPath.startsWith("/dental-identification/projects/case/all-records")
  ) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (
      pathParts.length === 6 &&
      pathParts[4] === "all-records" &&
      pathParts[5]
    ) {
      title = "All Records";
    }
  }

  // If title not found, use the default title
  title = title || "Default Title";

  return (
    <div className="app_header">
      <div className="page_title">
        <Breadcrumb />
      </div>
      <div>{/* <img src={notificationIcon} alt="notification" /> */}</div>
    </div>
  );
};

export default AppHeader;
